import { type FC } from 'react';

import { Spinner } from 'dibs-elements/exports/Spinner.tsx';
import overlayStyles from './OverlaySpinnerAdditional.scss';

export const Loader: FC = () => (
    <div className={overlayStyles.container}>
        <Spinner />
    </div>
);
